import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";

export const TAG_PICKER_PAGE_SIZE = 5;
const TAGS_ADMIN_PAGE_SIZE = 15;

export const getAllTags = async (
    selectedTenant: string,
    currentPage: number,
    searchQuery: string,
    pageSize = TAGS_ADMIN_PAGE_SIZE
) => {
    if (!selectedTenant) return;
    const url = searchQuery
        ? `${NGROK}/api/tags/search?q=${searchQuery}&page=${currentPage}&size=${pageSize}`
        : `${NGROK}/api/tags/all?page=${currentPage}&size=${pageSize}`;
    const data = await apiClient({
        method: "GET",
        url: url + `&tenantName=${selectedTenant}`
    });

    return data;
};

/** Tag dropdown: search with fallback to default list; initial load uses page size 5. */
export const searchTagsForPicker = async (
    tenantName: string,
    searchQuery = "",
    page = 0
) => {
    if (!tenantName) {
        return { content: [], totalPages: 1 };
    }

    const trimmedSearch = searchQuery.trim();
    if (trimmedSearch.length > 0) {
        let response = await getAllTags(tenantName, page, trimmedSearch, TAG_PICKER_PAGE_SIZE);
        const searchResults = response?.content ?? [];
        if (searchResults.length === 0) {
            response = await getAllTags(tenantName, page, "", TAG_PICKER_PAGE_SIZE);
        }
        return response;
    }

    return getAllTags(tenantName, page, "", TAG_PICKER_PAGE_SIZE);
};
/** Loads every tag page so assigned tag names can be resolved to stable IDs before save. */
export const fetchAllTagsForTenant = async (
    tenantName: string,
    searchQuery = ""
): Promise<Array<{ id: number; name: string }>> => {
    if (!tenantName) return [];

    const allTags: Array<{ id: number; name: string }> = [];
    let page = 0;
    let totalPages = 1;

    while (page < totalPages) {
        const response = await getAllTags(tenantName, page, searchQuery);
        const content = response?.content ?? [];
        allTags.push(...content);
        totalPages = response?.totalPages ?? 1;
        page += 1;
    }

    return allTags;
};

export const createTags = async (payload: any) => {
    const url = `${NGROK}/api/tags/create`;
    const data = await apiClient({
        method: "POST",
        url,
        data: payload
    });

    return data;
};

export const updateTag = async (id: string, tagName: string, tenantName: string, tagdescription: string) => {
    const url = `${NGROK}/api/tags/update/${id}?name=${tagName}&description=${tagdescription}`;
    const data = await apiClient({
        method: "PATCH",
        url,
    });
    return data;
}


export const deleteTag = async (tagId: string) => {
    const url = `${NGROK}/api/tags/delete/${tagId}`;
    const data = await apiClient({
        method: "DELETE",
        url
    });

    return data;
};